import React from 'react';
import VideoContainer from './VideoContainer';
import PrivatePageHOC from '../../containers/PrivatPageHOC/PrivatePageHOC';

const SoterTaskVideo = () => {
  return <VideoContainer />;
};

export default PrivatePageHOC(SoterTaskVideo);
